import React from "react";
import * as PropTypes from "prop-types";
import { methods } from "../../../constants";
import PivotTable from "../../table/PivotTable";

const MethodVsSectorTable = props => (
  <PivotTable
    titles={[
      {
        key: "methods",
        title: "",
        columnSpan: 1
      },
      {
        key: "total",
        title: "",
        columnSpan: 1,
        total: true
      },
      {
        key: "sectors",
        title: "",
        columnSpan: 2,
        groupEnd: true
      },
      {
        key: "privateSector",
        title: "Within Private",
        columnSpan: 2
      }
    ]}
    columnKey="sector"
    columnDefinitions={[
      {
        value: "Total",
        total: true
      },
      {
        value: "Public"
      },
      {
        value: "Private",
        groupEnd: true
      },
      {
        value: "Private Sub",
        label: "Subsidized"
      },
      {
        value: "Private Non-Sub",
        label: "Non-Subsidized"
      }
    ]}
    rowKey="method"
    rowDefinitions={[
      ...methods.map(method => ({
        value: method
      })),
      {
        value: "Total",
        total: true
      }
    ].slice(0, props.showTotals ? undefined : -1)}
    data={props.data}
  />
);

MethodVsSectorTable.propTypes = {
  data: PropTypes.array.isRequired,
  showTotals: PropTypes.bool
};

MethodVsSectorTable.defaultProps = {
  showTotals: true
};

export default MethodVsSectorTable;
